import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';
import {FormattedHTMLMessage} from 'react-intl';
import withAuthControl from '../auth/Auth.js';
import TopScrolleable from './TopScrolleable.js'
import Section from './Section.js'
import CustomSpinner from './CustomSpinner';
import RenderField from './RenderField';
import CustomAlert from '../components/CustomAlert.js';
import StatesList from '../containers/StatesContainer.js';
import { WAButton } from '../components/Button.js';
import CustomAutosuggestMobileFriendly from './CustomAutosuggestMobileFriendly';


class AddressForm extends Component {

    constructor(props) {
        super(props);
        this.state = { cities: null };
    }

    render() {
        const { handleSubmit, submitting, error, state_id } = this.props;

        const incomeField = (<div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                    <div className="form-group">
                                        <Field className="form-control" name="income" autoComplete="off" component={RenderField} type="number" label="Ingreso Neto Mensual" />
                                    </div>
                                </div>
                            </div>);



        return (
            <Section className="intro_form">
                <div className="row">
                    <div className="pd-content-left col-md-5 col-lg-5 text-center">
                        <img alt="Logo" className="center-block intro_logo" src={require(`../assets/${process.env.PAGE}/img/logo-h-blanco.png`)}/>
                        <FormattedHTMLMessage id="app.step_address" description="Address info"/>
                        <WAButton phone={this.context.intl.formatMessage({
                                      id:"app.step_sms_whatsapp_number", defaultMessage: "542612554220"})}
                                  text={this.context.intl.formatMessage({
                                      id:"app.step_sms_whatsapp_text", defaultMessage: "Tengo+una+consulta"})}
                                  value={this.context.intl.formatMessage({
                                      id:"app.step_sms_whatsapp_label", defaultMessage: "261-2554-220"})}
                                  gaEvent="true" gaCategory="CallToAction" gaAction="WhatsApp Tapping"/>
                        <FormattedHTMLMessage id="app.whatsapp_timetable" description="Wp timetable"/>
                    </div>
                    <div className="pd-content-right col-sm-12 col-md-7 col-lg-7">
                        <form onSubmit={handleSubmit(this.props.saveAddress)} className="pvc-form" autoComplete="asd">
                            {this.props.isLoading && <CustomSpinner message='Estamos analizando tu solicitud. Por favor esperá...' /> }
                            {error && <CustomAlert bsStyle="danger" message={error}/>}
                            <div className="row">
                                <StatesList />
                            </div>
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                    <div className="form-group">
                                        <Field className="form-control" name="form_locality" autoComplete="asd" component={CustomAutosuggestMobileFriendly} selectedState={state_id} type="text" label="Localidad" />
                                    </div>
                                </div>
                            </div>
                            
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                    <div className="form-group">
                                        <Field className="form-control" name="address_street" autoComplete="off" component={RenderField} type="text" label="Calle y Número" />
                                    </div>
                                </div>
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                    <div className="form-group">
                                        <Field className="form-control" name="address_description" autoComplete="off" component={RenderField} type="text" label="N° dpto, N° piso, etc" />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                    <div className="form-group">
                                        <Field className="form-control" name="zip_code" autoComplete="off" component={RenderField} type="number" label="Código Postal" />
                                    </div>
                                </div>
                            </div>
                            {incomeField}
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12 text-center">
                                    <button type="submit" className="btn btn-warning btn-lg pd-button pd-form" disabled={submitting}>Seguir</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </Section>
        );
    }
}

AddressForm.contextTypes = {
    intl: React.PropTypes.object.isRequired
}

const selector = formValueSelector('AddressForm')

AddressForm = connect(
    state => {
        const state_id = selector(state, 'state_id')
        return {
            state_id
        }
    }
)(AddressForm)

AddressForm = TopScrolleable(AddressForm);

AddressForm = reduxForm({
    form: 'AddressForm', // a unique name for this form
})(AddressForm);

AddressForm = withAuthControl(AddressForm);

export default AddressForm;



/** WEBPACK FOOTER **
 ** ./src/components/AddressForm.js
 **/